// libraries.
import { Outlet } from 'react-router-dom';

// components.
export const OrchestratorPricingCommitteePage = () => {
  return <Outlet />;
};
